import CheckIcon from '@mui/icons-material/Check';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../router/Routes';
import { LoadingWidget } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import CardNumberComponent from '../../dashboard/components/CardNumber';
import { estadisticasRecibosAction } from '../recibos/RecibosAction';
import { PARAMS_ESTADISTICAS_RECIBOS } from '../recibos/RecibosReducer';
import { getEstatusRecibosColor } from '../recibos/components/SelectEstatusRecibos';

const PanelAdministracionView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const recibosStore = Redux.useSelector((state) => state.recibos);

  React.useEffect(() => {
    async function fetchData() {
      const payload = {
        ...recibosStore.paramsEstadisticas,
        idEntidad: entidadesStore.activo.id,
      };
      dispatch({ type: PARAMS_ESTADISTICAS_RECIBOS, payload });

      if (!recibosStore.estadisticas) {
        await estadisticasRecibosAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <BotonComponent
          click={async () => {
            await estadisticasRecibosAction(
              dispatch,
              recibosStore.paramsEstadisticas,
            );
          }}
          disabled={recibosStore.loadingAll || !recibosStore.estadisticas}
          white
          refreshIcon
          text={recibosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
          mr={2}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <LoadingWidget isLoading={recibosStore.loadingAll} />
        <Grid container spacing={1}>
          <CardNumberComponent
            icon={<FormatListNumberedIcon size="large" />}
            text="Total"
            number={recibosStore.estadisticas?.total ?? 0}
            to={ROUTES.recibos.to}
          />
          <CardNumberComponent
            icon={<CloseIcon size="large" />}
            text="Pendientes"
            textColor={getEstatusRecibosColor(3)}
            number={recibosStore.estadisticas?.pendientes ?? 0}
          />
          <CardNumberComponent
            icon={<CheckCircleOutlineIcon size="large" />}
            text="Cancelados"
            textColor={getEstatusRecibosColor(7)}
            number={recibosStore.estadisticas?.cancelados ?? 0}
          />
          <CardNumberComponent
            icon={<CheckIcon size="large" />}
            text="Verificados"
            textColor={getEstatusRecibosColor(8)}
            number={recibosStore.estadisticas?.verificados ?? 0}
          />
          <CardNumberComponent
            icon={<WarningAmberIcon size="large" />}
            text="Invalidos"
            textColor={getEstatusRecibosColor(9)}
            number={recibosStore.estadisticas?.invalidos ?? 0}
          />
          <CardNumberComponent
            icon={<ErrorOutlineIcon size="large" />}
            text="Incompletos"
            textColor={getEstatusRecibosColor(10)}
            number={recibosStore.estadisticas?.incompletos ?? 0}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PanelAdministracionView;
